/* Copyright 2013 - 2024 Waiterio LLC */
/** @jsxImportSource @emotion/react */
import React from 'react'
import { css } from '@emotion/react'
import IconDone from '@stiloso/icons/IconDone.jsx'
import languages from '@monorepool/shared/languages.js'
import Modal from '@waiterio/components/Modal.jsx'
import slugs from '../slugs.js'

const locales = Object.keys(slugs)

const languageStyle = css({
  fontSize: 18,
  color: '#666',
  padding: 10,
  borderBottom: '1px solid #d3d3d3',
  fill: '#4393d0',
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  justifyContent: 'space-between',
  ':hover': {
    backgroundColor: '#4393d0',
    color: 'white',
    cursor: 'pointer',
    fill: 'white',
  },
})

const LanguageDialog = ({ currentLocale, close }) => (
  <Modal close={close}>
    <div
      css={{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        maxHeight: '80%',
      }}
    >
      <div css={languageStyle}>
        <span>{languages[currentLocale]}</span>
        <IconDone />
      </div>
      {locales.map(
        locale =>
          locale !== currentLocale && (
            <a href={`/docs/${locale}/`} key={locale} css={languageStyle}>
              {languages[locale]}
            </a>
          ),
      )}
    </div>
  </Modal>
)

export default LanguageDialog
